export default __webpack_public_path__ + "static/media/iconClose.463c590b.svg";